import React from 'react';
import PropTypes from 'prop-types';
import Button from "UI/Button";
import TextField from "UI/Form/TextField";

import validate from "Data/projects/ProjectValidators";
import Form from "Components/Form";
import Modal from "UI/Modal";

export default class CreateProjectDialog extends React.Component
{
    state = {
        busy: false,
    };

    static propTypes = {
        open: PropTypes.bool.isRequired,
        onClose: PropTypes.func.isRequired,
        accountId: PropTypes.string.isRequired,
        createProject: PropTypes.func.isRequired,
    };

    onClose = e => {
        if (e) {
            e.preventDefault();
        }

        this.setState({busy: false}, this.props.onClose);
    };

    onSubmit = (data) => {
        this.setState({busy: true}, () => {
            this.props.createProject(
                this.props.accountId,
                data.name,
                data.description
            ).then(
                () => this.onClose()
            ).catch(error => {
                this.setState({busy: false});
            });
        });
    };

    render()
    {
        const { open } = this.props;

        return <Modal open={open} onClose={this.onClose} className="w-full max-w-xs">
            <Modal.Header>
                Create Project
            </Modal.Header>
            <Modal.Content>
                <Form id='create-project' validate={validate} onSubmit={this.onSubmit}>
                    {(data, onChange, validation) =>
                        <fieldset disabled={this.state.busy} className='space-y-4'>
                            <TextField
                                id="name"
                                label="Project name"
                                value={data.name}
                                onChange={onChange('name')}
                                autoComplete="off"
                                error={validation.hasErrors('name')}
                                help={validation.getErrors('name')}
                            />

                            <TextField
                                id="description"
                                label="Brief description"
                                value={data.description}
                                onChange={onChange('description')}
                                hint='Optional'
                                autoComplete="off"
                                placeholder="e.g. Vouchers, Lottery funding"
                                error={validation.hasErrors('description')}
                                help={validation.getErrors('description')}
                            />
                        </fieldset>
                    }
                </Form>
            </Modal.Content>
            <Modal.Footer>
                <Button form='create-project' type="primary" busy={this.state.busy}>Create Project</Button>
                <Button onClick={this.onClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>;
    }
}